import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import i18nMgmt from './locale/i18n-mgmt-inst';
import VueI18n from 'vue-i18n';

import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/style/index.css';
import 'iceqerp-common/style/element-ui.scss';

import formValidation from 'iceqerp-common/formValidation';

Vue.prototype.$formValidation = formValidation;

var version = require('../version.json');
window.$version = version && version.value;

Vue.config.productionTip = false;
Vue.use(VueI18n);

i18nMgmt.init().then(({ lang, langPackage }) => {
  const messages = {};
  messages[lang] = langPackage;
  const i18n = new VueI18n({
    locale: lang,
    messages
  });

  Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
  });

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount('#app');
});